import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { ref as l } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { watch as n } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function s(r, u, i) {
  if (!u)
    return r;
  const e = l(r.value);
  let t = null;
  return n(r, (o) => {
    t !== null && window.clearTimeout(t), o === !0 ? i && !i.value ? e.value = !0 : t = window.setTimeout(() => {
      e.value = !0;
    }, u) : e.value = !1;
  }), e;
}
export {
  s as useDeferredTrue
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/composable/use-deferred-true.js
// module id = 1620
// module chunks = 67